import { IconButton, Popover, Tooltip } from '@tunasong/ui-lib'
import type { FC } from 'react'
import { useState } from 'react'
import styles from './melody-shortcuts-help.module.css'
import { melodyShortcuts } from './melody-shortcuts.js'

/**
 * The melody editor's shortcut help (melody toolkit M2; Joni's answer to Q6; spec §10): an icon-only `?`
 * in edit mode, hidden below 600px where there is no keyboard to speak of. It opens a popover listing
 * every shortcut the roll has; focus moves in, and Esc returns it to the button.
 */

const title = 'Keyboard shortcuts'

export interface MelodyShortcutsHelpProps {
  className?: string
}

export const MelodyShortcutsHelp: FC<MelodyShortcutsHelpProps> = props => {
  const { className } = props
  const [anchor, setAnchor] = useState<HTMLButtonElement | null>(null)
  const [isOpen, setOpen] = useState(false)

  return (
    <span className={className ? `${styles.help} ${className}` : styles.help}>
      <Tooltip title={title}>
        <IconButton ref={setAnchor} size="small" aria-label={title} onClick={() => setOpen(true)}>
          <span aria-hidden="true">?</span>
        </IconButton>
      </Tooltip>
      <Popover open={isOpen} anchorEl={anchor} onClose={() => setOpen(false)} aria-label={title}>
        <div className={styles.content}>
          <h2 className={styles.title}>{title}</h2>
          <dl className={styles.rows}>
            {melodyShortcuts.map(({ key, description }) => (
              <div key={key} className={styles.row}>
                <dt>
                  <kbd className={styles.key}>{key}</kbd>
                </dt>
                <dd className={styles.description}>{description}</dd>
              </div>
            ))}
          </dl>
          <p className={styles.footnote}>These work while the roll, or a chord in the lane, has focus.</p>
        </div>
      </Popover>
    </span>
  )
}
